import React from "react";
import PropTypes from "prop-types";
import Image from "theme/components/atoms/Image";
import EnhanceProductGallery from "./EnhanceProductGallery";
import ProductGalleryQuery from "./ProductGalleryQuery.gql";
import ErrorBoundary from "theme/components/helpers/ErrorBoundary";
import GalleryWithCarousel from "./GalleryWithCarousel";
import useFullUrl from "web/core/shop/useFullUrl";

const ProductGallery = ({
  loading,
  images,
  product,
  numberOfVisibleThumbnails,
  imageSizes,
  thumbSizes,
}) => {
  const fullImageUrl = useFullUrl(product.imageUrl, false);
  return (
    <>
      <meta itemProp="image" content={fullImageUrl} />
      <ErrorBoundary>
        {({ hasError }) =>
          // Display only the main image in case of an error
          hasError ? (
            <div className="container--tablet-only">
              <div className="product-gallery">
                <Image
                  src={product.imageUrl}
                  alt={product.name}
                  format="medium"
                  appearance="full"
                  priority
                  sizes={imageSizes}
                />
              </div>
            </div>
          ) : (
            <GalleryWithCarousel
              name={product.name}
              loading={loading}
              images={images}
              numberOfVisibleThumbnails={numberOfVisibleThumbnails}
              imageSizes={imageSizes}
              thumbSizes={thumbSizes}
            />
          )
        }
      </ErrorBoundary>
    </>
  );
};

ProductGallery.propTypes = {
  mainImageSrc: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      file: PropTypes.string.isRequired,
    })
  ),
  name: PropTypes.string,
  onImageClick: PropTypes.func,
};

const SmartGallery = EnhanceProductGallery({ ProductGalleryQuery })(
  ProductGallery
);

export default SmartGallery;
